import { Layout, Dropdown, Avatar, Typography } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { BreadcrumbProvider } from "../context/BreadcrumbContext";
import { HistoryProvider } from "../context/HistoryContext";
import { Breadcrumbs } from "./Breadcrumbs";
import { RecentPages } from "./RecentPages";
import { NotificationBell } from "./NotificationBell";
import { ApprovalsBell } from "./ApprovalsBell";
import { GlobalSearch } from "./GlobalSearch";
import { TutorialBar } from "../tutorials/TutorialContext";

const { Header, Content } = Layout;

// Navigation is card-driven (landing page → module hub → page); the layout carries only
// the brand, the breadcrumb trail back up, and the account controls.
export function AppLayout() {
  const { user, logout } = useUser();
  const navigate = useNavigate();

  return (
    <BreadcrumbProvider>
      <HistoryProvider>
        <Layout className="glut-app-layout">
          <TutorialBar />
          <Header className="glut-header">
            <Link to="/" className="glut-brand">
              <img src="/logo.png" alt="" className="glut-brand-logo" />
              Glut
            </Link>
            <div className="glut-header-actions">
              <GlobalSearch />
              <ApprovalsBell />
              <NotificationBell />
              <Dropdown
                trigger={["click"]}
                menu={{
                  items: [{ key: "logout", icon: <LogoutOutlined />, label: "Log out", onClick: () => logout().then(() => navigate("/login")) }],
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                  <Avatar size="small" icon={<UserOutlined />} />
                  <Typography.Text>{user?.name}</Typography.Text>
                </div>
              </Dropdown>
            </div>
          </Header>
          <Content className="glut-content">
            {/* Where you are on the left, where you have been on the right. */}
            <div className="glut-crumb-bar">
              <Breadcrumbs />
              <RecentPages />
            </div>
            <Outlet />
          </Content>
        </Layout>
      </HistoryProvider>
    </BreadcrumbProvider>
  );
}
